/**
 * @file: debug.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

const enabledDebuggers = {
  taskManager: true,
  keyboardManager: false,
  shareReport: true,
  wework: true,
  productManifest: true,
  linking: true,
  quotation: true,
  statusBar: true,
  notification: true,
  snackbar: true,
};

export const isDebugEnabled = (key: keyof typeof enabledDebuggers): boolean =>
  __DEV__ && enabledDebuggers[key];
